var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusFillCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_7078",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 7078",
    transform: "translate(-614 -9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5871",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 5871",
    d: "M17,0A17,17,0,1,1,0,17,17,17,0,0,1,17,0Z",
    transform: "translate(614 9)",
    fill: "#4FB2ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041E\\u0431\\u044A\\u0435\\u0434\\u0438\\u043D\\u0435\\u043D\\u0438\\u0435_193",
    "data-name": "\\u041E\\u0431\\u044A\\u0435\\u0434\\u0438\\u043D\\u0435\\u043D\\u0438\\u0435 193",
    d: "M-16891.48-8080.484v-7.037h-7.039a1.482,1.482,0,0,1-1.48-1.48,1.482,1.482,0,0,1,1.48-1.48h7.039v-7.036A1.483,1.483,0,0,1-16890-8099a1.483,1.483,0,0,1,1.48,1.484v7.036h7.041a1.482,1.482,0,0,1,1.48,1.48,1.482,1.482,0,0,1-1.48,1.48h-7.041v7.037a1.479,1.479,0,0,1-1.48,1.48A1.479,1.479,0,0,1-16891.48-8080.484Z",
    transform: "translate(17521 8115.003)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusFillCircleIcon);
export default __webpack_public_path__ + "static/media/plusFillCircleIcon.436f111e.svg";
export { ForwardRef as ReactComponent };